import { BaseResourceModel } from "../outros/base-resource.model";

export class MatriculaLogModel extends BaseResourceModel {
    id?: number;
    cnpj: string;
    nomeCandidato?: string; 
    cpf?: string; 
    filiacaoPai?: string; 
    filiacaoMae?: string; 
    rg?: string; 
    rgExpedidoEm?: Date; 
    rgExpedidoPor?: string; 
    estadoCivil?: string; 
    profissao?: string;
    telefone?: string; 
    email?: string; 
    dataAniversario?: Date; 
    endereco?: string;
    enderecoNumero?: string; 
    complemento?: string; 
    bairro?: string; 
    cidade?: string; 
    cep?: string;
    naturalidade?: string; 
    imgFace?: string; 
    renach?: string; 
    situacao?: string; 
    servicosId?: number; 
    categoriaCnhId?: number;
    observacaoProcesso?: string; 
    dataAberturaRenach?: Date;
    dataVencimentoRenach?: Date; 
    numeroNotaFiscal?: string; 
    codigoVerificador?: string; 
    dataEmissaoNotaFiscal?: Date; 
    ativo?: boolean;
    usuarioCadastro?: string;
    dataCadastro?: any;
    usuarioAlteracao?: string;
    dataAlteracao?: any;
    numero?: string;

    constructor(options: MatriculaLogModel = { cnpj: "" }) {
        super();
        this.id = options.id || null;
        this.cnpj = options.cnpj || null;
        this.nomeCandidato = options.nomeCandidato || null;
        this.cpf = options.cpf || null;
        this.filiacaoPai = options.filiacaoPai || null;
        this.filiacaoMae = options.filiacaoMae || null;
        this.rg = options.rg || null;
        this.rgExpedidoEm = options.rgExpedidoEm || null;
        this.rgExpedidoPor = options.rgExpedidoPor || null;
        this.estadoCivil = options.estadoCivil || null;
        this.profissao = options.profissao || null;
        this.telefone = options.telefone || null;
        this.email = options.email || null;
        this.dataAniversario = options.dataAniversario || null;
        this.endereco = options.endereco || null;
        this.enderecoNumero = options.enderecoNumero || null;
        this.complemento = options.complemento || null;
        this.bairro = options.bairro || null;
        this.cidade = options.cidade || null;
        this.cep = options.cep || null;
        this.naturalidade = options.naturalidade || null;
        this.imgFace = options.imgFace || null;
        this.renach = options.renach || null;
        this.situacao = options.situacao || null;
        this.servicosId = options.servicosId || null;
        this.categoriaCnhId = options.categoriaCnhId || null;
        this.observacaoProcesso = options.observacaoProcesso || null;
        this.dataAberturaRenach = options.dataAberturaRenach || null;
        this.dataVencimentoRenach = options.dataVencimentoRenach || null;
        this.numeroNotaFiscal = options.numeroNotaFiscal || null;
        this.codigoVerificador = options.codigoVerificador || null;
        this.dataEmissaoNotaFiscal = options.dataEmissaoNotaFiscal || null;
        this.ativo = options.ativo || null;
        this.usuarioCadastro = options.usuarioCadastro || null;
        this.dataCadastro = options.dataCadastro || null;
        this.usuarioAlteracao = options.usuarioAlteracao || null;
        this.dataAlteracao = options.dataAlteracao || null;
        this.numero = options.numero || null;
    }
}

class Processo {
    id?: number;
    candidatoId?: number;
    renach?: string;
    situacao?: string;
    servicosId?: number;
    categoriaCnhId?: number;
    dataAberturaRenach?: any;
    dataVencimentoRenach?: any;
    usuarioCadastro?: string;
    dataCadastro?: any;
    observacao?: string;
    candidatoNome?: string;
    ativo?: boolean;
    servico?: Servico;
    categoriaCnh?: CategoriaCnh;

    constructor(options: Processo = {}) {
        this.id = options.id || null;
        this.candidatoId = options.candidatoId || null;
        this.renach = options.renach || null;
        this.situacao = options.situacao || null;
        this.servicosId = options.servicosId || null;
        this.categoriaCnhId = options.categoriaCnhId || null;
        this.dataAberturaRenach = options.dataAberturaRenach || null;
        this.dataVencimentoRenach = options.dataVencimentoRenach || null;
        this.usuarioCadastro = options.usuarioCadastro || null;
        this.dataCadastro = options.dataCadastro || null;
        this.observacao = options.observacao || null;
        this.candidatoNome = options.candidatoNome || null;
        this.ativo = options.ativo || null;
        this.servico = options.servico || new Servico();
        this.categoriaCnh = options.categoriaCnh || new CategoriaCnh();
    }
}

class Servico {
    id?: number;
    nome?: string;
    ativo?: boolean;
    codigoExterno?: string;
    requerRenach?: boolean;
    usuarioCadastro?: string;
    dataCadastro?: any;
    usuarioAlteracao?: string;
    dataAlteracao?: any;

    constructor(options: Servico = {}) {
        this.id = options.id || null;
        this.nome = options.nome || null;
        this.ativo = options.ativo || null;
        this.codigoExterno = options.codigoExterno || null;
        this.requerRenach = options.requerRenach || null;
        this.usuarioCadastro = options.usuarioCadastro || null;
        this.dataCadastro = options.dataCadastro || null;
        this.usuarioAlteracao = options.usuarioAlteracao || null;
        this.dataAlteracao = options.dataAlteracao || null;
    }
}

class CategoriaCnh {
    id?: number;
    categoria?: string;
    ativo?: boolean;
    usuarioAlteracao?: string;
    dataAlteracao?: any;
    usuarioCadastro?: string;
    dataCadastro?: any;

    constructor(options: CategoriaCnh = {}) {
        this.id = options.id || null;
        this.categoria = options.categoria || null;
        this.ativo = options.ativo || null;
        this.usuarioAlteracao = options.usuarioAlteracao || null;
        this.dataAlteracao = options.dataAlteracao || null;
        this.usuarioCadastro = options.usuarioCadastro || null;
        this.dataCadastro = options.dataCadastro || null;
    }
}

export class MatriculaLogRequestModel {
    id?: number;
    candidatoId?: number;
    processoId?: number;
    candidatoNome?: string;
    candidatoCpf?: string;
    candidatoFiliacaoPai?: string | null;
    candidatoFiliacaoMae?: string | null;
    candidatoRg?: string | null;
    candidatoRgExpedidoEm?: Date | null;
    candidatoRgExpedidoPor?: string | null;
    candidatoEstadoCivil?: string | null;
    candidatoProfissao?: string | null;
    candidatoTelefone?: string;
    candidatoEmail?: string;
    candidatoDataAniversario?: Date;
    candidatoEndereco?: string | null;
    candidatoEnderecoNumero?: string | null;
    candidatoComplemento?: string | null;
    candidatoBairro?: string | null;
    candidatoCidade?: string | null;
    candidatoCep?: string | null;
    candidatoNaturalidade?: string | null;
    candidatoImgFace?: string;
    cfcId?: number;
    numero?: string;
    observacao?: string;
    status?: string | null;
    justificativaCancelamento?: string | null;
    numeroNotaFiscal?: string | null;
    codigoVerificador?: string | null;
    dataEmissaoNotaFiscal?: Date | null;

    constructor(options: MatriculaLogRequestModel = {}) {
        this.id = options.id || null;
        this.candidatoId = options.candidatoId || null;
        this.processoId = options.processoId || null;
        this.candidatoNome = options.candidatoNome || null;
        this.candidatoCpf = options.candidatoCpf || null;
        this.candidatoFiliacaoPai = options.candidatoFiliacaoPai || null;
        this.candidatoFiliacaoMae = options.candidatoFiliacaoMae || null;
        this.candidatoRg = options.candidatoRg || null;
        this.candidatoRgExpedidoEm = options.candidatoRgExpedidoEm ? new Date(options.candidatoRgExpedidoEm) : null;
        this.candidatoRgExpedidoPor = options.candidatoRgExpedidoPor || null;
        this.candidatoEstadoCivil = options.candidatoEstadoCivil || null;
        this.candidatoProfissao = options.candidatoProfissao || null;
        this.candidatoTelefone = options.candidatoTelefone || null;
        this.candidatoEmail = options.candidatoEmail || null;
        this.candidatoDataAniversario = options.candidatoDataAniversario ? new Date(options.candidatoDataAniversario) : null;
        this.candidatoEndereco = options.candidatoEndereco || null;
        this.candidatoEnderecoNumero = options.candidatoEnderecoNumero || null;
        this.candidatoComplemento = options.candidatoComplemento || null;
        this.candidatoBairro = options.candidatoBairro || null;
        this.candidatoCidade = options.candidatoCidade || null;
        this.candidatoCep = options.candidatoCep || null;
        this.candidatoNaturalidade = options.candidatoNaturalidade || null;
        this.candidatoImgFace = options.candidatoImgFace || null;
        this.cfcId = options.cfcId || null;
        this.numero = options.numero || null;
        this.observacao = options.observacao || null;
        this.status = options.status || null;
        this.justificativaCancelamento = options.justificativaCancelamento || null;
        this.numeroNotaFiscal = options.numeroNotaFiscal || null;
        this.codigoVerificador = options.codigoVerificador || null;
        this.dataEmissaoNotaFiscal = options.dataEmissaoNotaFiscal ? new Date(options.dataEmissaoNotaFiscal) : null;
    }
}